import axios from "axios";
import { KeyUri } from "../key";

// Shared, cached requests so Tours, DestinationShowcase and LastMinuteEscapes
// hit the backend once instead of three times.
let toursPromise = null;
let upcomingPromise = null;

// Tiny sessionStorage cache so a revisit / refresh paints instantly while the
// fresh data is fetched in the background (stale-while-revalidate).
export const readCache = (key, maxAgeMs = 30 * 60 * 1000) => {
  try {
    const r = JSON.parse(sessionStorage.getItem(`tg:${key}`));
    if (r && Date.now() - r.t < maxAgeMs) return r.v;
  } catch (e) { /* storage unavailable or corrupt: ignore */ }
  return null;
};
export const writeCache = (key, value) => {
  try { sessionStorage.setItem(`tg:${key}`, JSON.stringify({ t: Date.now(), v: value })); } catch (e) { /* quota: ignore */ }
};
const departuresCache = new Map();

export const fetchToursCached = () => {
  if (!toursPromise) {
    toursPromise = axios
      .get(`${KeyUri.BACKEND_URI}/get-tours?view=list&available=true`)
      .then((res) => (Array.isArray(res.data) ? res.data : []))
      .catch((err) => {
        toursPromise = null; // allow retry on next mount
        throw err;
      });
  }
  return toursPromise;
};

export const fetchDeparturesCached = (tourId) => {
  if (!departuresCache.has(tourId)) {
    departuresCache.set(
      tourId,
      axios
        .get(`${KeyUri.BACKEND_URI}/get-departures/${tourId}`)
        .then((res) => res.data?.data || [])
        .catch(() => [])
    );
  }
  return departuresCache.get(tourId);
};

export const isDomesticTour = (t) =>
  t.tour_type === "domestic" ||
  (!t.tour_type && (!t.country || String(t.country).toLowerCase() === "india"));


// One shared request for the last-minute strip (deduped, cached for the session)
export const fetchUpcomingCached = (params) => {
  if (!upcomingPromise) {
    upcomingPromise = axios
      .get(`${KeyUri.BACKEND_URI}/get-upcoming-departures`, { params })
      .then((res) => { writeCache("upcoming", res.data); return res.data; })
      .catch((err) => { upcomingPromise = null; throw err; });
  }
  return upcomingPromise;
};

// Public tour coupons for the home page strip (one deduped request per session).
// Same endpoint + validity rules the TourDetail coupon modal uses.
let couponsPromise = null;
export const fetchPublicCouponsCached = () => {
  if (!couponsPromise) {
    couponsPromise = axios
      .get(`${KeyUri.BACKEND_URI}/get-tour-coupon/public`)
      .then((res) => {
        const raw = res.data?.coupons || res.data?.data || res.data || [];
        return Array.isArray(raw) ? raw : [];
      })
      .catch((err) => { couponsPromise = null; throw err; });
  }
  return couponsPromise;
};

// Is this coupon usable right now? (active, in date range, not exhausted)
export const isCouponLive = (c, now = new Date()) => {
  if (!c || !c.is_active) return false;
  if (c.valid_from && new Date(c.valid_from) > now) return false;
  if (c.valid_until && new Date(c.valid_until) < now) return false;
  if (c.usage_limit && c.used_count >= c.usage_limit) return false;
  return true;
};